import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export const getNotifications = async (pathname, queryParams = "") => {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams);
};

export const markNotificationAsRead = async (pathname, body) => {
  try {
    return await instance({
      baseURL: baseURL,
    }).patch("/notification" + pathname, body);
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};

export const markAllNotificationsAsRead = async (
  pathname,

  body) => {
  try {
    return await instance({
      baseURL: baseURL,
    }).patch("/notification" + pathname, body);
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};
